import { isValidSelector, isNestingAllowed } from 'anodum';
import findAllFor from '../filters/find-all-for';

const canBeNested = (element, parentElement) => {
  const constraints = findAllFor(element);

  return constraints.some((constraint) => {
    if (!isValidSelector(constraint.parent)) return false;
    return parentElement.matches(constraint.parent) && isNestingAllowed(element, parentElement);
  });
};

export default canBeNested;
